"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createImagingProcedures = createImagingProcedures;
const events_1 = require("../../../events");
const shared_1 = require("../../shared");
const messages_1 = require("./messages");
const queries_1 = require("../queries");
const messages = {
    imagingProcedures: {
        id: "ktx.dashboard.imaging_procedures",
        defaultMessage: "Képalkotó vizsgálatok"
    }
};
var ImagingProcedureResult;
(function (ImagingProcedureResult) {
    ImagingProcedureResult["NORMAL"] = "NORMAL";
    ImagingProcedureResult["ABNORMAL"] = "ABNORMAL";
})(ImagingProcedureResult || (ImagingProcedureResult = {}));
const groups = [
    {
        label: messages_1.messages.abnormal,
        variant: "dark",
        predicate: (event) => {
            return (event !== undefined &&
                event.value.result === ImagingProcedureResult.ABNORMAL);
        }
    },
    {
        label: messages_1.messages.normal,
        variant: "light",
        predicate: (event) => event !== undefined &&
            event.value.result === ImagingProcedureResult.NORMAL
    }
];
const values = Object.values(queries_1.imagingProcedureQueries).map(query => ({
    query,
    label: shared_1.fsnMessages[(0, events_1.mapInterpretationToString)(query.interpretation)]
}));
function createImagingProcedures(intl, { events }) {
    const list = (0, shared_1.createGroupList)(intl, { events, groups, values });
    const content = (0, shared_1.createSectionContent)([list]);
    return (0, shared_1.createSection)(intl, { label: messages.imagingProcedures, content });
}
